import { createSelector } from '@ngrx/store';

import { getCurrentRoute } from '../getCurrentRoute';

export const isCurrentRouteResetPasswordPage = createSelector(getCurrentRoute, (current) => current?.url?.startsWith('/reset-password') || false);
